import React, { useEffect, useState } from "react";
import styles from "./Error.module.scss";
import classnames from "classnames";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TurnrErrorAlert } from "./TurnrAlert";
import { serviceHasError, serviceIsSuccessfullyFetched } from "rylak-common";

function PopupComponent({ alert }) {
    const [show, setShow] = useState(true);
    const [hiding, setHiding] = useState(false);
    const [hidden, setHidden] = useState(false);
    const title = alert?.title;
    const content = alert?.content;

    useEffect(() => {
        if (show) {
            setTimeout(function () {
                setHiding(true);
                setShow(false);
            }, 5000);
        }
    }, [show]);

    useEffect(() => {
        if (hiding) {
            setTimeout(function () {
                setHidden(true);
            }, 300);
        }
    }, [hiding]);

    return hidden ? (
        <></>
    ) : (
        <div className={classnames(styles["error-popup"], !show && styles["error-popup-hide"], show && styles["error-popup-show"])}>
            <div className={classnames(styles["error-popup-inner"])}>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                    }}
                    onClick={() => {
                        setShow(false);
                        setHiding(true);
                    }}
                >
                    <FontAwesomeIcon
                        style={{
                            height: "30px",
                            width: "30px",
                            padding: "15px",
                        }}
                        icon={faXmark}
                        size={"sm"}
                    />
                </div>
                {title && <h2 className={styles["error-popup-header"]}>{title}</h2>}
                {content && <div className={styles["error-popup-content"]}>{content}</div>}
            </div>
        </div>
    );
}

export function ServiceAlertPopup({ serviceData, successFn, successText, errorText, addAlert }) {
    useServicePopup({
        serviceData,
        successFn,
        successText,
        errorText,
        addAlert,
    });
    return <></>;
}

export function useServicePopup({ serviceData, successFn, errorText, addAlert }) {
    useEffect(() => {
        // If we want this later
        // if (!serviceIsSuccessfullyFetched(serviceData) && (!successFn || successFn(serviceData))) {
        //     addAlert({content: successText || "Success!", type: "SUCCESS"})
        // }
        if (serviceHasError(serviceData) || (successFn && serviceIsSuccessfullyFetched(serviceData) && !successFn(serviceData))) {
            addAlert({
                content: errorText || serviceData?.message || serviceData?.statusText,
                type: "ERROR",
            });
        }
    }, [serviceData]);
}

export function AlertPopupWrapper({ alerts }) {
    return (
        <div className={styles["error-popup-container"]}>
            {alerts.map((alert, index) => {
                return <PopupComponent key={index} alert={alert} />;
            })}
        </div>
    );
}

export function ServiceErrorAlert({ serviceData, getLocaleText, localeKey, centerPage, style = {} }) {
    if (!serviceData?.error) {
        return null;
    }

    return <ErrorAlert centerPage={centerPage} style={style} text={getErrorText({ getLocaleText, localeKey, serviceData })} />;
}

export function ErrorAlert({ text, centerPage, style = {} }) {
    return (
        <div
            style={{
                width: "100%",
                ...style,
                ...(centerPage && {
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }),
            }}
        >
            <TurnrErrorAlert fullWidth={true}>{text}</TurnrErrorAlert>
        </div>
    );
}

function formatSnakeCaseToSentence(str) {
    return str
        .toLowerCase() // convert entire string to lowercase
        .split("_") // split by underscores
        .map((word, index) => {
            if (index === 0) {
                return word.charAt(0).toUpperCase() + word.slice(1); // capitalize the first word
            }
            return word;
        })
        .join(" "); // join with space
}

export function getStatusTextLine({ serviceData }) {
    return formatSnakeCaseToSentence(serviceData.statusText || "");
}

export function getErrorText({ getLocaleText, localeKey, serviceData }) {
    if (!getLocaleText) {
        console.error("WARNING: getLocaleText is mandatory in getErrorText");
        return serviceData.message || "Something went wrong";
    }
    if (!serviceData?.error) {
        return null;
    }
    let errorText;
    if (localeKey) {
        errorText =
            getLocaleText(`${localeKey}.ERROR.${serviceData.statusText}`) ||
            getLocaleText(`${localeKey}.ERROR.DEFAULT`) ||
            getLocaleText(`ERROR.${serviceData.statusText}`) ||
            getLocaleText(`ERROR.DEFAULT`);
    }

    if (!errorText) {
        return serviceData.message || "Something went wrong";
    }

    const statusTextLine = getStatusTextLine({ serviceData });

    return (
        <div>
            {errorText}
            {statusTextLine && <>. {statusTextLine}.</>}
        </div>
    );
}

export function ErrorText(props) {
    const { errorText, text } = props;
    return ServiceErrorText({
        ...props,
        errorText: errorText || text,
        serviceData: { error: errorText || text },
    });
}

export function ServiceErrorText({ serviceData, getLocaleText, localeKey, errorText, style, className }) {
    if (!serviceData?.error) {
        return null;
    }
    return (
        <p className={classnames(styles["error-message"], className)} style={style}>
            {errorText || getErrorText({ getLocaleText, localeKey, serviceData })}
        </p>
    );
}
